import { useMemo } from 'react';

import { useCheckoutV2ExperimentGate } from 'experiments/checkout-v2/use-enable-checkout-v2-experiment';
import { routes } from 'utils/routing';

export const usePendingSubmittedOrderCheckoutRoute = () => {
  const { isReady, isTreatment } = useCheckoutV2ExperimentGate();

  return useMemo(() => {
    if (!isReady) {
      return null;
    }

    return isTreatment ? routes.cartCheckout : routes.cartPayment;
  }, [isReady, isTreatment]);
};
